import React, { useEffect, useState } from "react";
import "./youtubeVideo.css";

const YouTubeVideos = () => {
    const [videos, setVideos] = useState([]);
    const channelId = "UCDnHdrxuWJUb8aFkxuUJgCA"; // Dynamic Channel ID
    const channelUrl = `https://www.youtube.com/channel/${channelId}`;

    useEffect(() => {
        const fetchYouTubeVideos = async () => {
            try {
                const response = await fetch(
                    `https://api.rss2json.com/v1/api.json?rss_url=https://www.youtube.com/feeds/videos.xml?channel_id=${channelId}`
                );
                const data = await response.json();
                setVideos(data.items.slice(0, 4)); // Limit to 4 videos
            } catch (error) {
                console.error("Error fetching YouTube videos:", error);
            }
        };
        fetchYouTubeVideos();
    }, [channelId]);

    return (
        <section id="youtube" className="py-12 md:py-16 lg:py-20" style={{background: 'linear-gradient(to bottom, rgba(var(--bg-dark),0.06), rgba(var(--bg-dark),0.09))'}}>
            <div className="max-w-6xl mx-auto px-3 md:px-4">
                <h1 className="pixel-title text-center text-2xl sm:text-3xl md:text-4xl mb-8 md:mb-12" style={{color: 'rgb(var(--primary-accent))'}}>STREAM ARCHIVE</h1>

                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
                    {videos.map((video, index) => (
                        <div key={index} className="video-card hud-panel rounded-sm p-2 md:p-3" style={{background: 'rgba(var(--bg-dark),0.5)', border: '2px solid rgba(var(--primary-accent),0.12)'}}>
                            <div className="aspect-video w-full overflow-hidden rounded-sm">
                                <iframe
                                    src={`https://www.youtube.com/embed/${video.link.split("v=")[1]}`}
                                    title={video.title}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    className="w-full h-full"
                                ></iframe>
                            </div>
                            <h3 className="mt-2 md:mt-3 text-xs sm:text-sm md:text-base arcade-title" style={{color: 'rgb(var(--primary-accent))'}}>{video.title}</h3>
                        </div>
                    ))}
                </div>

                <div className="mt-6 md:mt-8 text-center">
                    <a href={channelUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-3 md:px-4 py-2 rounded-sm arcade-title text-xs sm:text-sm md:text-base transition-colors" style={{background: 'rgba(var(--primary-accent),0.08)', color: 'rgb(var(--primary-accent))', border: '1px solid rgba(var(--primary-accent),0.16)'}}>
                        STAY TUNED
                    </a>
                </div>
            </div>
        </section>
    );
};

export default YouTubeVideos;
